import { Button, Col, Form, Input, Row, Table } from 'antd';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import regex from '../../../../constants/system.keys';

const LicenseCheckSection = ({
  form,
  onCheckCode,
  license,
  licenseInfo,
  service,
}) => {
  const { t } = useTranslation();

  return (
    <Col span={6} className="step-1-col">
      <div className="form-check-code">
        <Form
          form={form}
          layout="inline"
          name="register-service"
          onFinish={(values) => onCheckCode(values?.checkCode?.trim())}
        >
          <Row style={{ width: '100%' }}>
            <Col span={18}>
              <Form.Item
                style={{ width: '97%' }}
                name="checkCode"
                rules={[
                  {
                    required: true,
                    message: t('Please enter the license code!'),
                  },
                  {
                    pattern: regex.isurl,
                    message: t('Please enter the license code!'),
                  },
                  {
                    max: 80,
                    message: t('Please input up to 80 characters!'),
                  },
                ]}
              >
                <Input
                  style={{ width: '100%' }}
                  placeholder="License Code"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item style={{ width: '100%' }}>
                <Button
                  type="primary"
                  style={{ width: '100%' }}
                  htmlType="submit"
                >
                  {t('Check')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {license && license.licenseCode && (
          <div className="license-info">
            {t('License')} <span>{license.licenseCode}</span> {t('has')}
            <span>
              {` ${license.size - license.numberActive}/${license.size} `}
            </span>
            {t('of the remaining activation.')}
          </div>
        )}
        {licenseInfo?.licenseCode && (
          <Table
            pagination={false}
            scroll={{ y: 155 }}
            style={{ border: '1px solid #303030' }}
            size="small"
            columns={[
              {
                title: t('Create date'),
                dataIndex: 'startAt',
                key: 'startAt',
                align: 'center',
                render: (time) => moment(time).format('DD/MM/YYYY'),
              },
              {
                title: t('Activated'),
                dataIndex: 'numberActive',
                key: 'numberActive',
                align: 'center',
                render: (numberActive) =>
                  `${numberActive ?? 0}/${licenseInfo.size ?? 0}`,
              },
              {
                title: t('Duration'),
                dataIndex: 'duration',
                key: 'duration',
                align: 'center',
              },
            ]}
            dataSource={licenseInfo ? [licenseInfo] : []}
          />
        )}
      </div>
      <div className="description">
        <span>{t('Description')}: </span>
        {service && service.description}
      </div>
    </Col>
  );
};

export default LicenseCheckSection;
